"use client";

import type { ReactNode } from "react";
import { MetaTags } from "@rangojs/router/client";
import styles from "./index.css?url";

export function Document({ children }: { children: ReactNode }) {
  return (
    <html lang="en">
      <head>
        <link rel="preload" href={styles} as="style" />
        <link rel="stylesheet" href={styles} />
        <MetaTags />
      </head>
      <body className="font-sans antialiased text-slate-900 bg-slate-50">{children}</body>
    </html>
  );
}
